class UZKitBuilderUtility{
    cname = "uzkbCartItems";
    constructor(){}
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i=0; i<vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) {
          return pair[1];
        }
      }

      return false;
    }

    getCartItems(){
        var savedItemsJSONString = this.getCookie(this.cname);
        var savedItemsJSON = [];
        try {
            savedItemsJSON = JSON.parse(savedItemsJSONString);
        } catch (e) {
            savedItemsJSON = [];
        }
        return savedItemsJSON;
    }
    saveCartItemCookie(vid, newItem){
        //newItem["key"] = vid;
        //this.setCookie(this.cname, JSON.stringify([]), 365);
        
        var savedItemsJSON = this.getCartItems();
        //console.log(savedItemsJSON);
        var isNew = true;
        Object.entries(savedItemsJSON).forEach(item => {
            const [key, value] = item;
            if (JSON.stringify(newItem) != JSON.stringify(item)){
                //isNew = false;
            }
            
        });
        if (isNew){
            savedItemsJSON.push(newItem);
            //console.log("New Item");
            //console.log(savedItemsJSON);
            this.setCookie(this.cname, JSON.stringify(savedItemsJSON), 365);
        }
        
        
        
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
      genRandomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
    }
}